import {
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UniversityService } from '../../services';

@Component({
  selector: 'app-university-form-page',
  templateUrl: './university-form-page.component.html',
})
export class UniversityFormPageComponent implements OnInit {
  @HostBinding('class.form-page-component')
  hostClass = true;
  initialized = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: UniversityService
  ) {}

  async ngOnInit(): Promise<void> {
    const translationKey = this.route.snapshot.paramMap.get(
      'translationKey'
    );
    this.service.isNew = !translationKey;

    if (!translationKey) {
      this.service.formState.item =
        UniversityService.factoryItem();
      this.initialized = true;
      return;
    }

    try {
      this.service.formState.item =
        await this.service.loadByTranslationKey(
          translationKey
        );
    } catch {
      await this.router.navigate(['/home/university']);
    } finally {
      this.initialized = true;
    }
  }

  get headline(): string {
    return this.service.isNew
      ? 'label.university.create'
      : 'label.university.edit';
  }

  get loading(): boolean {
    return (
      !this.initialized || this.service.formState.loading
    );
  }
}
